import { render, staticRenderFns } from "./AccisureForm.vue?vue&type=template&id=1ab49bf1&scoped=true"
import script from "./AccisureForm.vue?vue&type=script&lang=js"
export * from "./AccisureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab49bf1",
  null
  
)

export default component.exports